import ExcelJS from "exceljs";
import {
  applyDataBorder,
  getCompanyName,
  hideSheetGridlines,
  moneyFmt,
  styleLightHeader,
} from "./payrollReportExcelShared";
import { formatInrLakhs } from "./payrollDashboardAnalytics";

async function downloadWorkbook(workbook, filename) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
  return filename;
}

/** Export a single dashboard card drill-down to Excel. */
export async function exportPayrollCardExcel(detail) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "PaceHRM";
  const ws = workbook.addWorksheet("Card detail");
  hideSheetGridlines(ws);

  ws.mergeCells(1, 1, 1, 4);
  ws.getCell(1, 1).value = `${getCompanyName()} - ${detail?.title || "Card"}`;
  ws.getCell(1, 1).font = { bold: true, size: 13 };
  ws.mergeCells(2, 1, 2, 4);
  ws.getCell(2, 1).value = `Period: ${detail?.periodLabel || "-"} | Status: ${
    detail?.status || "-"
  } | ${new Date().toLocaleString("en-IN")}`;
  ws.getCell(2, 1).font = { size: 9, color: { argb: "FF6B7280" } };

  ["Field", "Value", "Value (Lakhs)"].forEach((h, i) => {
    const cell = ws.getCell(4, i + 1);
    cell.value = h;
    styleLightHeader(cell, "FFD1FAE5");
  });

  (detail?.summary || []).forEach((row, idx) => {
    const r = 5 + idx;
    const [k, v] = row;
    ws.getCell(r, 1).value = k;
    if (typeof v === "number") {
      ws.getCell(r, 2).value = v;
      moneyFmt(ws.getCell(r, 2));
      ws.getCell(r, 3).value = formatInrLakhs(v);
    } else {
      ws.getCell(r, 2).value = v == null ? "-" : String(v);
      ws.getCell(r, 3).value = "";
    }
    [1, 2, 3].forEach((c) => applyDataBorder(ws.getCell(r, c)));
  });

  if (detail?.trendRows?.length) {
    const start = 5 + (detail.summary?.length || 0) + 2;
    ws.getCell(start, 1).value = "Trend";
    ws.getCell(start, 1).font = { bold: true };
    const headers = ["Month", "Status", "HC", "Fixed", "Cost", "Cash", "Net"];
    headers.forEach((h, i) => {
      const cell = ws.getCell(start + 1, i + 1);
      cell.value = h;
      styleLightHeader(cell, "FFE0E7FF");
    });
    detail.trendRows.forEach((row, idx) => {
      const r = start + 2 + idx;
      const vals = [
        row.payMonth,
        row.status,
        row.headcount,
        row.fixedCost,
        row.totalCost,
        row.totalCashFlow,
        row.netPay,
      ];
      vals.forEach((v, i) => {
        const cell = ws.getCell(r, i + 1);
        cell.value = v;
        if (i >= 3) moneyFmt(cell);
        applyDataBorder(cell);
      });
    });
  }

  if (detail?.note) {
    const noteRow = 5 + (detail.summary?.length || 0) + (detail.trendRows?.length || 0) + 6;
    ws.getCell(noteRow, 1).value = detail.note;
    ws.getCell(noteRow, 1).font = { italic: true, size: 9, color: { argb: "FF6B7280" } };
  }

  ws.getColumn(1).width = 32;
  ws.getColumn(2).width = 18;
  ws.getColumn(3).width = 16;

  const filename = `Payroll_Card_${String(detail?.title || "detail")
    .replace(/[^a-zA-Z0-9_]+/g, "_")
    .slice(0, 30)}_${new Date().toISOString().slice(0, 10)}.xlsx`;
  await downloadWorkbook(workbook, filename);
  return filename;
}
